// The only module that reads the build environment. Vite exposes the REACT_APP_* variables on
// import.meta.env (`envPrefix` in vite.config.mjs), where CRA used process.env.
// Vite replaces only the literal `import.meta.env` expression, so it must not be destructured.
// eslint-disable-next-line prefer-destructuring
const env = import.meta.env;

// The flag variables hold JSON (`true`, `false`); the parsed value is used for its truthiness only.
const parseJsonFlag = (value: string | undefined): unknown => (value ? JSON.parse(value) : false);

export default {
  isDevelopment: !env.PROD,
  isProduction: env.PROD,
  projectsReportUrl: '/api/reports/projects',
  registeredUsersReportUrl: '/api/reports/registered-users',
  loanConsultantsUrl: '/api/reports/loan-consultants',
  customerDataAnalyticsUrl: '/api/reports/customer-data-analytics',
  expressLoanPdf: '/_pdf/express_loan',
  appName: env.REACT_APP_NAME,
  debug: parseJsonFlag(env.REACT_APP_DEBUG),
  apiUrl: env.REACT_APP_API_URL,
  rootUrl: env.REACT_APP_ROOT_URL,
  defaultLocale: env.REACT_APP_DEFAULT_LOCALE,
  privacyPolicy: env.REACT_APP_PRIVACY_POLICY,
  graphqlServerUrl: env.REACT_APP_GRAPHQL_SERVER_URL,
  googleAnalytics: env.REACT_APP_GOOGLE_ANALYTICS,
  googleAuthenticatorPlayMarket: env.REACT_APP_PLAY_MARKET_GOOGLE_AUTHENTICATOR,
  googleAuthenticatorAppStore: env.REACT_APP_STORE_GOOGLE_AUTHENTICATOR,
  // The path the app is served under (`base` in vite.config.mjs, from PUBLIC_URL) without the
  // trailing slash, the value CRA exposed as process.env.PUBLIC_URL.
  publicUrl: env.BASE_URL.replace(/\/$/, ''),
};
